import { Injectable } from '@angular/core';

import { MenuStoreService } from './menu-store.service';

@Injectable({
    providedIn: 'root'
})
export class MenuFacadeService {

    constructor(private menuStore: MenuStoreService) {}

    init(): void {
        this.menuStore.dispatch.init();
    }

}
